import React, { useState, useEffect } from 'react';
import { collection, addDoc, query, where, getDocs, getDoc, doc, collectionGroup } from 'firebase/firestore';
import { db } from '../components/firebase-config.js';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { 
  faCalendarPlus, 
  faSpinner, 
  faCheck, 
  faTimes, 
  faArrowLeft, 
  faInfoCircle,
  faExchangeAlt,
  faCreditCard,
  faMoneyBillWave,
  faHome,
  faSearch,
  faCalendarCheck,
  faHospital,
  faLink,
  faExternalLinkAlt,
  faPhone,
  faGlobe
} from '@fortawesome/free-solid-svg-icons';
import 'bootstrap/dist/css/bootstrap.min.css';

const Quick = () => {
  // ID fixe de la structure qui recevra toutes les demandes
  const STRUCTURE_ID = "PIBDAA1l9JSPsUbgIiiHdCvKtff2"; // Remplacez par l'ID de votre structure
  const STRUCTURE_NOM = "CABINET D'OPHTALMOLOGIE  Dr MAR NDIAYE"; // Remplacez par le nom de votre structure

  // Configuration PayTech
  const payTechConfig = {
     api_key: "0360fc1c628c4527a6035a75d63bbd9ec2ad27da5e56b39be53019a36578c80c",
    api_secret: "3f2048b8e427fa67a3a6341bcfe3795abc05cdd68ad101d6f51ebe6734340b9c",
    env: "test",
    ipn_url: "https://www.drmarndiayeophtalmo.com/Quick/ipn",
    success_url: "https://www.drmarndiayeophtalmo.com/Quick",
    cancel_url: "https://www.drmarndiayeophtalmo.com/Quick"
  };

  
  // État pour naviguer entre les volets
  const [activePanel, setActivePanel] = useState('booking');

  // États pour gérer les différentes vues
  const [currentView, setCurrentView] = useState('booking'); // 'booking', 'success', 'verification'
  const [currentStep, setCurrentStep] = useState(1); // Pour le formulaire multi-étapes
  
  // État du formulaire de rendez-vous
  const [formData, setFormData] = useState({
    nom: '',
    prenom: '',
    dateNaissance: '',
    email: '',
    telephone: '',
    dateRdv: '',
    heureRdv: '',
    medecinId: '',
    motif: '',
    statut: 'confirmé',
    structureId: STRUCTURE_ID // Par défaut, notre structure
  });

  // États pour les données de la structure et des médecins
  const [medecins, setMedecins] = useState([]);
  const [creneauxDisponibles, setCreneauxDisponibles] = useState([]);
  const [rendezvous, setRendezvous] = useState([]);
  
  // États divers
  const [loading, setLoading] = useState(false);
  const [loadingMedecins, setLoadingMedecins] = useState(true);
  const [message, setMessage] = useState({ text: '', type: '' });
  const [isMobile, setIsMobile] = useState(false);
  const [verificationCode, setVerificationCode] = useState('');
  
  // États pour gérer le paiement
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [paymentStatus, setPaymentStatus] = useState(null); // null, 'success', 'failed'
  const [paymentInfo, setPaymentInfo] = useState({
    amount: 100,
    reference: '',
    method: '',
    status: ''
  });
  const [paymentModalUrl, setPaymentModalUrl] = useState('');
  
  // États pour gérer les spécialités
  const [specialites, setSpecialites] = useState([]);
  const [selectedSpecialite, setSelectedSpecialite] = useState('');
  
  // Nouveaux états pour les structures externes
  const [allStructures, setAllStructures] = useState([]);
  const [allSpecialites, setAllSpecialites] = useState([]);
  const [loadingStructures, setLoadingStructures] = useState(false);
  const [selectedStructure, setSelectedStructure] = useState(STRUCTURE_ID);
  const [externalSpecialites, setExternalSpecialites] = useState([]);
  const [isExternalSpeciality, setIsExternalSpeciality] = useState(false);
  
  // Add new state for initial view
  const [initialView, setInitialView] = useState(true);
  
  // Add new states for embedded iframes
  const [showHomeConsultModal, setShowHomeConsultModal] = useState(false);
  const [showIframe, setShowIframe] = useState(false);
  const [iframeUrl, setIframeUrl] = useState('');
  const [iframeTitle, setIframeTitle] = useState('');
  
  // Nouveaux états pour la vérification des rendez-vous
  const [verificationSearchCode, setVerificationSearchCode] = useState('');
  const [verificationResult, setVerificationResult] = useState(null);
  const [loadingVerification, setLoadingVerification] = useState(false);
  
  // Détection de l'appareil
  useEffect(() => {
    const checkIfMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    
    checkIfMobile();
    window.addEventListener('resize', checkIfMobile);
    return () => window.removeEventListener('resize', checkIfMobile);
  }, []);

  // Charger les données au chargement du composant
  useEffect(() => {
    fetchMedecins();
    fetchRendezvous();
    fetchAllStructures(); // Nouvelle fonction pour récupérer toutes les structures
    fetchAllSpecialites(); // Nouvelle fonction pour récupérer toutes les spécialités
  }, []);

  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const paymentStatus = queryParams.get('payment_status');
    const paymentRef = queryParams.get('ref');
    
    if (paymentStatus && paymentRef) {
      // Nettoyer l'URL
      window.history.replaceState({}, document.title, window.location.pathname);
      
      if (paymentStatus === 'success') {
        // Paiement réussi
        setPaymentStatus('success');
        setPaymentInfo(prevInfo => ({
          ...prevInfo,
          status: 'payé',
          method: 'PayTech',
          reference: paymentRef
        }));
        setMessage({ text: "Paiement effectué avec succès! Vous pouvez maintenant confirmer votre rendez-vous.", type: "success" });
        
        // S'assurer que l'utilisateur reste sur l'étape de finalisation
        setCurrentStep(3);
        setCurrentView('booking');
      } else if (paymentStatus === 'cancel') {
        // Paiement annulé
        setPaymentStatus('failed');
        setPaymentInfo(prevInfo => ({
          ...prevInfo,
          status: 'échoué',
          reference: paymentRef
        }));
        setMessage({ text: "Le paiement a été annulé. Veuillez réessayer avant de confirmer votre rendez-vous.", type: "error" });
        
        // S'assurer que l'utilisateur reste sur l'étape de finalisation
        setCurrentStep(3);
        setCurrentView('booking');
      }
    }
  }, []);

  // Nouvelle fonction pour récupérer toutes les structures
  const fetchAllStructures = async () => {
    try {
      setLoadingStructures(true);
      const structuresQuery = query(collection(db, 'structures'));
      const querySnapshot = await getDocs(structuresQuery);
      
      if (querySnapshot.empty) {
        console.log("Aucune structure trouvée dans la base de données");
        setAllStructures([]);
      } else {
        const structuresList = [];
        querySnapshot.forEach((doc) => {
          const structureData = { id: doc.id, ...doc.data() };
          structuresList.push(structureData);
        });
        setAllStructures(structuresList);
        console.log("Structures récupérées:", structuresList.length);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des structures:", error);
    } finally {
      setLoadingStructures(false);
    }
  };

  // Nouvelle fonction pour récupérer toutes les spécialités disponibles
  const fetchAllSpecialites = async () => {
    try {
      // Utiliser collectionGroup pour récupérer tous les médecins de toutes les structures
      const medecinsQuery = query(collection(db, 'medecins'));
      const querySnapshot = await getDocs(medecinsQuery);
      
      if (querySnapshot.empty) {
        console.log("Aucun médecin trouvé dans la base de données");
        setAllSpecialites([]);
      } else {
        const specialitesSet = new Set();
        
        querySnapshot.forEach((doc) => {
          const medecinData = doc.data();
          if (medecinData.specialite) {
            specialitesSet.add(medecinData.specialite);
          }
        });
        
        // Convertir le Set en tableau et trier
        const specialitesArray = Array.from(specialitesSet).sort();
        setAllSpecialites(specialitesArray);
        console.log("Spécialités récupérées:", specialitesArray.length);
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des spécialités:", error);
    }
  };

  // Récupérer les médecins de la structure
  const fetchMedecins = async (structureId = STRUCTURE_ID) => {
    try {
      setLoadingMedecins(true);
      const q = query(collection(db, 'medecins'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        setMessage({ 
          text: "Aucun médecin n'est disponible pour cette structure.", 
          type: "error" 
        });
        setMedecins([]);
        setSpecialites([]);
      } else {
        const medecinsList = [];
        const specialitesSet = new Set(); // Utiliser un Set pour éviter les doublons
        
        querySnapshot.forEach((doc) => {
          const medecinData = { id: doc.id, ...doc.data() };
          medecinsList.push(medecinData);
          
          // Ajouter la spécialité au Set si elle existe
          if (medecinData.specialite) {
            specialitesSet.add(medecinData.specialite);
          }
        });
        
        setMedecins(medecinsList);
        // Convertir le Set en tableau pour l'état
        setSpecialites(Array.from(specialitesSet).sort());
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des médecins:", error);
      setMessage({ 
        text: "Impossible de charger les médecins. Veuillez réessayer plus tard.", 
        type: "error" 
      });
    } finally {
      setLoadingMedecins(false);
    }
  };

  // Récupérer les rendez-vous existants
  const fetchRendezvous = async (structureId = STRUCTURE_ID) => {
    try {
      const q = query(collection(db, 'rendezvous'), where("structureId", "==", structureId));
      const querySnapshot = await getDocs(q);
      
      const rdvList = [];
      querySnapshot.forEach((doc) => {
        rdvList.push({ id: doc.id, ...doc.data() });
      });
      setRendezvous(rdvList);
    } catch (error) {
      console.error("Erreur lors de la récupération des rendez-vous:", error);
    }
  };

  // Nouvelle fonction pour trouver les structures qui offrent une spécialité spécifique
  const findStructuresWithSpeciality = async (specialite) => {
    try {
      setLoadingMedecins(true);
      const q = query(collection(db, 'medecins'), where("specialite", "==", specialite));
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        console.log(`Aucun médecin trouvé pour la spécialité: ${specialite}`);
        return [];
      } else {
        // Utiliser un Set pour éviter les doublons de structures
        const structuresSet = new Set();
        const structuresList = [];
        
        querySnapshot.forEach((doc) => {
          const medecinData = doc.data();
          if (medecinData.structureId && !structuresSet.has(medecinData.structureId)) {
            structuresSet.add(medecinData.structureId);
            
            // Trouver les détails de la structure
            const structure = allStructures.find(s => s.id === medecinData.structureId);
            if (structure) {
              structuresList.push(structure);
            }
          }
        });
        
        return structuresList;
      }
    } catch (error) {
      console.error("Erreur lors de la recherche des structures:", error);
      return [];
    } finally {
      setLoadingMedecins(false);
    }
  };

  // Vérifier la disponibilité du médecin
  const verifierDisponibilite = (medecinId, date, heure) => {
      // Trouver le médecin
      const medecin = medecins.find(m => m.id === medecinId);
      if (!medecin) return false;
      
      // Vérifier le jour de la semaine
      const jourDate = new Date(date);
      const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
      const jourSemaine = joursMap[jourDate.getDay()];
      
      // Vérifier si le médecin travaille ce jour-là
      let disponibiliteJour = null;
      if (Array.isArray(medecin.disponibilites)) {
        disponibiliteJour = medecin.disponibilites.find(d => 
          d.jour.toLowerCase() === jourSemaine.toLowerCase()
        );
      } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
        disponibiliteJour = medecin.disponibilites[jourSemaine].actif ? {
          heureDebut: medecin.disponibilites[jourSemaine].debut,
          heureFin: medecin.disponibilites[jourSemaine].fin
        } : null;
      }
      
      if (!disponibiliteJour) return false;
      
      // Vérifier si l'heure est dans la plage de disponibilité
      const heureDebut = disponibiliteJour.heureDebut || disponibiliteJour.debut;
      const heureFin = disponibiliteJour.heureFin || disponibiliteJour.fin;
      
      if (heure < heureDebut || heure > heureFin) return false;
      
      // Calculer l'heure de fin du rendez-vous avec une durée fixe de 15 minutes
      const dureeFixe = 15; // Durée fixe en minutes
      const [heureH, heureM] = heure.split(':').map(Number);
      const heureFinRdv = new Date();
      heureFinRdv.setHours(heureH, heureM + dureeFixe, 0, 0);
      const heureFinStr = `${heureFinRdv.getHours().toString().padStart(2, '0')}:${heureFinRdv.getMinutes().toString().padStart(2, '0')}`;
      
      if (heureFinStr > heureFin) return false;
      
      // Vérifier les chevauchements avec d'autres rendez-vous
      const rdvDuJour = rendezvous.filter(rdv => 
        rdv.medecinId === medecinId && 
        rdv.date === date && 
        rdv.statut !== 'annulé'
      );
      
      // Compter les rendez-vous à cette heure précise
      const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
      
      // Nombre maximum de rendez-vous simultanés autorisés
      const MAX_RDV_SIMULTANES = 3;
      
      // Si nous avons déjà atteint le nombre maximum de rendez-vous à cette heure
      if (rdvAuCreneau.length >= MAX_RDV_SIMULTANES) {
        return false;
      }
      
      return true;
  };

  // Obtenir les créneaux disponibles avec statut
  const getCreneauxAvecStatut = () => {
    if (!formData.medecinId || !formData.dateRdv) return [];
    
    const medecin = medecins.find(m => m.id === formData.medecinId);
    if (!medecin) return [];
    
    // Déterminer le jour de la semaine
    const jourDate = new Date(formData.dateRdv);
    const joursMap = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
    const jourSemaine = joursMap[jourDate.getDay()];
    
    // Obtenir les horaires du médecin pour ce jour
    let heureDebut = '08:00';
    let heureFin = '18:00';
    let disponibiliteJour = null;
    
    if (Array.isArray(medecin.disponibilites)) {
      disponibiliteJour = medecin.disponibilites.find(d => 
        d.jour.toLowerCase() === jourSemaine.toLowerCase()
      );
      
      if (disponibiliteJour) {
        heureDebut = disponibiliteJour.heureDebut;
        heureFin = disponibiliteJour.heureFin;
      } else {
        return []; // Le médecin ne travaille pas ce jour
      }
    } else if (medecin.disponibilites && medecin.disponibilites[jourSemaine]) {
      if (!medecin.disponibilites[jourSemaine].actif) {
        return []; // Le médecin ne travaille pas ce jour
      }
      heureDebut = medecin.disponibilites[jourSemaine].debut;
      heureFin = medecin.disponibilites[jourSemaine].fin;
    } else {
      return []; // Pas de disponibilités pour ce jour
    }
    
    // Récupérer les rendez-vous existants pour ce médecin et cette date
    const rdvDuJour = rendezvous.filter(rdv => 
      rdv.medecinId === formData.medecinId && 
      rdv.date === formData.dateRdv && 
      rdv.statut !== 'annulé'
    );
    
    // Générer tous les créneaux possibles (par tranches de 15 minutes)
    const tousLesCreneaux = [];
    let heure = heureDebut;
    
    // Nombre maximum de rendez-vous simultanés autorisés
    const MAX_RDV_SIMULTANES = 3;
    
    // Définir une durée fixe
    const dureeFixe = 15;
    
    while (heure < heureFin) {
      const [h, m] = heure.split(':').map(Number);
      const heureFinCreneau = new Date();
      heureFinCreneau.setHours(h, m + dureeFixe, 0, 0);
      const heureFinStr = `${heureFinCreneau.getHours().toString().padStart(2, '0')}:${heureFinCreneau.getMinutes().toString().padStart(2, '0')}`;
      
      if (heureFinStr <= heureFin) {
        // Compter le nombre de rendez-vous à cette heure
        const rdvAuCreneau = rdvDuJour.filter(rdv => rdv.heure === heure);
        const nombreRdvAuCreneau = rdvAuCreneau.length;
        
        // Déterminer le statut du créneau
        let statut = 'disponible';
        if (nombreRdvAuCreneau >= MAX_RDV_SIMULTANES) {
          statut = 'complet';
        } else if (nombreRdvAuCreneau > 0) {
          statut = 'partiel';
        }
        
        tousLesCreneaux.push({
          heure: heure,
          statut: statut,
          nombreRdv: nombreRdvAuCreneau,
          estDisponible: statut !== 'complet'
        });
      }
      
      // Passer au créneau suivant (par tranches de 15 minutes)
      const nextHeure = new Date();
      nextHeure.setHours(h, m + 15, 0, 0);
      heure = `${nextHeure.getHours().toString().padStart(2, '0')}:${nextHeure.getMinutes().toString().padStart(2, '0')}`;
    }
    
    return tousLesCreneaux;
  };

  // Générer un code de vérification aléatoire
  const generateVerificationCode = () => {
    const chars = 'ABCDEFGHJKLMNPQRSTUVWXYZ23456789';
    let code = '';
    for (let i = 0; i < 8; i++) {
      code += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return code;
  };

  // Gérer les changements dans le formulaire
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    
    // Si le médecin ou la date change, mettre à jour les créneaux disponibles
    if (name === 'medecinId' || name === 'dateRdv') {
      if (formData.medecinId && name === 'dateRdv' && value) {
        // Mettre à jour les créneaux uniquement si on a un médecin et une date
        const creneaux = getCreneauxAvecStatut();
        setCreneauxDisponibles(creneaux);
      } else if (name === 'medecinId' && value && formData.dateRdv) {
        // Mettre à jour les créneaux si on change de médecin et qu'on a déjà une date
        const creneaux = getCreneauxAvecStatut();
        setCreneauxDisponibles(creneaux);
      }
    }
  };

  // Validation du formulaire
  const isFormValid = () => {
    const requiredFields = ['telephone', 'dateRdv', 'heureRdv', 'medecinId'];
    return requiredFields.every(field => formData[field]);
  };

  // Gestion des étapes du formulaire
  const isCurrentStepValid = () => {
    switch (currentStep) {
      case 1:
        return formData.telephone;
      case 2:
        return formData.medecinId && formData.dateRdv;
      case 3:
        return formData.heureRdv && formData.motif;
      default:
        return false;
    }
  };

  const handleNextStep = () => {
    if (isCurrentStepValid()) {
      if (currentStep === 2) {
        // Calculer les créneaux disponibles après avoir sélectionné le médecin et la date
        const creneaux = getCreneauxAvecStatut();
        setCreneauxDisponibles(creneaux);
      }
      setCurrentStep(currentStep + 1);
    } else {
      setMessage({ text: "Veuillez remplir tous les champs obligatoires.", type: "error" });
    }
  };

  const handlePrevStep = () => {
    setCurrentStep(currentStep - 1);
  };

  // Formater la date pour l'affichage
  const formatDate = (dateString) => {
    const options = { day: '2-digit', month: '2-digit', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('fr-FR', options);
  };

  // Ajouter une fonction pour générer une référence de paiement unique
  const generatePaymentReference = () => {
    return 'PAY-' + Date.now() + '-' + Math.floor(Math.random() * 1000);
  };

  // Fonction pour gérer le changement de spécialité
  const handleSpecialiteChange = async (e) => {
    const value = e.target.value;
    setSelectedSpecialite(value);
    
    if (value === 'domicile') {
      // Ouvrir l'iframe pour les consultations à domicile
      const domicileUrl = "https://sen-amd.vercel.app";
      setIframeUrl(domicileUrl);
      setIframeTitle("Consultation à domicile");
      setShowIframe(true);
      setIsExternalSpeciality(false);
    } else if (value) {
      // Vérifier si la spécialité est disponible dans notre structure
      const isLocalSpeciality = specialites.includes(value);
      
      if (isLocalSpeciality) {
        // Spécialité disponible localement
        setIsExternalSpeciality(false);
        setSelectedStructure(STRUCTURE_ID);
        setFormData(prev => ({ ...prev, medecinId: '', structureId: STRUCTURE_ID }));
      } else {
        // Spécialité externe - trouver les structures qui l'offrent
        setIsExternalSpeciality(true);
        const structuresWithSpeciality = await findStructuresWithSpeciality(value);
        
        if (structuresWithSpeciality.length > 0) {
          setExternalSpecialites(structuresWithSpeciality);
          setMessage({ 
            text: `La spécialité "${value}" est disponible dans ${structuresWithSpeciality.length} autre(s) structure(s).`, 
            type: "info" 
          });
        } else {
          setExternalSpecialites([]);
          setMessage({ 
            text: `Aucune structure ne propose actuellement la spécialité "${value}".`, 
            type: "error" 
          });
        }
        
        // Réinitialiser le médecin sélectionné
        setFormData(prev => ({ ...prev, medecinId: '' }));
      }
    }
  };

  // Nouvelle fonction pour gérer le changement de structure
  const handleStructureChange = async (e) => {
    const structureId = e.target.value;
    setSelectedStructure(structureId);
    
    // Mettre à jour l'ID de la structure dans le formulaire
    setFormData(prev => ({ ...prev, structureId: structureId, medecinId: '' }));
    
    // Charger les médecins de cette structure
    await fetchMedecins(structureId);
    await fetchRendezvous(structureId);
    
    // Trouver le nom de la structure
    const structure = allStructures.find(s => s.id === structureId);
    if (structure) {
      setMessage({ 
        text: `Vous consultez maintenant les médecins de la structure: ${structure.nom}`, 
        type: "info" 
      });
    }
  };

  // Modifier cette fonction pour qu'elle soit appelée lors de la soumission du formulaire
  const initializePayment = async () => {
    try {
      setLoading(true);
      // Montant par défaut pour la consultation
      const amount = 100; // 100 FCFA 
      
      // Générer une référence unique pour le paiement
      const paymentRef = generatePaymentReference();
      
      // Trouver le nom de la structure sélectionnée
      let structureNom = STRUCTURE_NOM;
      if (formData.structureId !== STRUCTURE_ID) {
        const structure = allStructures.find(s => s.id === formData.structureId);
        if (structure) {
          structureNom = structure.nom;
        }
      }
      
      // Préparer les données pour l'API Paytech
      const paymentData = {
        item_name: `Consultation médicale - ${structureNom}`,
        item_price: amount,
        currency: "XOF",
        ref_command: paymentRef,
        command_name: `Consultation médicale - ${structureNom}`,
        env: payTechConfig.env,
        ipn_url: payTechConfig.ipn_url,
        success_url: payTechConfig.success_url + "?payment_status=success&ref=" + paymentRef,
        cancel_url: payTechConfig.cancel_url + "?payment_status=cancel&ref=" + paymentRef,
        customer_id: `PATIENT-${formData.nom}-${Date.now()}`,
        customer_email: formData.email || 'client@example.com',
        customer_phone_number: formData.telephone,
        customer_address: "",
        customer_city: "Dakar",
        customer_country: "SN",
        customer_state: "Dakar",
        customer_zip_code: "12345"
      };
      
      console.log("Envoi des données à PayTech:", paymentData);
      
      // Effectuer l'appel API à Paytech
      const response = await fetch('https://paytech.sn/api/payment/request-payment', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'API_KEY': payTechConfig.api_key,
          'API_SECRET': payTechConfig.api_secret
        },
        body: JSON.stringify(paymentData)
      });
      
      if (!response.ok) {
        throw new Error(`Erreur HTTP: ${response.status} ${response.statusText}`);
      }
      
      const responseData = await response.json();
      console.log("Réponse de PayTech:", responseData);
      
      if (responseData && responseData.success) {
        // Enregistrer les informations de paiement
        setPaymentInfo({
          amount: amount,
          reference: paymentRef,
          method: 'PayTech',
          status: 'en attente',
          paymentToken: responseData.token
        });
        
        // Stocker les données du formulaire dans localStorage avant de rediriger
        localStorage.setItem('quickAppointmentFormData', JSON.stringify(formData));
        
        // Au lieu d'ouvrir un popup, rediriger directement vers l'URL de paiement
        window.location.href = responseData.redirect_url;
      } else {
        setMessage({ 
          text: responseData?.message || "Erreur lors de l'initialisation du paiement. Veuillez réessayer.", 
          type: "error" 
        });
      }
    } catch (error) {
      console.error("Erreur lors de l'initialisation du paiement:", error);
      setMessage({ text: "Erreur lors de l'initialisation du paiement. Veuillez réessayer.", type: "error" });
    } finally {
      setLoading(false);
    }
  };

  // Ajouter une fonction pour restaurer les données du formulaire depuis localStorage
  useEffect(() => {
    const savedFormData = localStorage.getItem('quickAppointmentFormData');
    if (savedFormData) {
      try {
        const parsedData = JSON.parse(savedFormData);
        setFormData(parsedData);
        
        // Si la structure est différente de la structure par défaut, charger les médecins de cette structure
        if (parsedData.structureId && parsedData.structureId !== STRUCTURE_ID) {
          setSelectedStructure(parsedData.structureId);
          fetchMedecins(parsedData.structureId);
          fetchRendezvous(parsedData.structureId);
        }
        
        // Ne pas effacer les données tout de suite pour permettre la finalisation du rendez-vous
      } catch (error) {
        console.error("Erreur lors de la restauration des données du formulaire:", error);
      }
    }
  }, []);

  // Fonction pour soumettre le formulaire
  const handleSubmit = async (e) => {
    e.preventDefault();
    
    // Vérifier si tous les champs requis sont remplis
    if (!formData.telephone || !formData.dateRdv || !formData.heureRdv || !formData.medecinId) {
      setMessage({ text: "Veuillez remplir tous les champs obligatoires", type: "error" });
      return;
    }
    
    try {
      setLoading(true);
      
      // Générer un code de vérification
      const code = generateVerificationCode();
      setVerificationCode(code);
      
      // Récupérer les informations du médecin sélectionné
      const medecin = medecins.find(m => m.id === formData.medecinId);
      
      // Trouver le nom de la structure sélectionnée
      let structureNom = STRUCTURE_NOM;
      let structureId = formData.structureId;
      
      if (structureId !== STRUCTURE_ID) {
        const structure = allStructures.find(s => s.id === structureId);
        if (structure) {
          structureNom = structure.nom;
        }
      }
      
      // Formater la date et l'heure pour correspondre au format de StructureDashboard
      const dateObj = new Date(formData.dateRdv);
      const formattedDate = dateObj.toISOString().split('T')[0];
      
      // Créer un timestamp pour createdAt
      const createdAt = new Date();

      // Créer d'abord le patient
      const patientData = {
        nom: formData.nom.trim(),
        prenom: formData.prenom.trim(),
        dateNaissance: formData.dateNaissance,
        email: formData.email ? formData.email.trim() : '',
        telephone: formData.telephone.trim().replace(/\s+/g, ''),
        structureId: structureId,
        createdAt: createdAt,
        updatedAt: createdAt,
        assurances: [],
        adresse: '',
        sexe: '',
        profession: '',
        antecedents: {
          medicaux: [],
          chirurgicaux: [],
          familiaux: [],
          allergies: []
        }
      };

      // Ajouter le patient à la base de données
      const patientRef = await addDoc(collection(db, 'patients'), patientData);
      
      // Préparer les données du rendez-vous avec une durée fixe
      const rdvData = {
        // Informations du rendez-vous
        date: formattedDate,
        heure: formData.heureRdv,
        duree: 15, // Durée fixe de 15 minutes
        motif: formData.motif.trim(),
        type: 'consultation',
        statut: 'confirmé',
        source: 'quick',
        verificationCode: code,
        
        // Informations de la structure
        structureId: structureId,
        structureNom: structureNom,
        
        // Métadonnées
        createdAt: createdAt,
        updatedAt: createdAt,

        // Informations du patient avec ID
        patientId: patientRef.id,
        patientNom: formData.nom.trim(),
        patientPrenom: formData.prenom.trim(),
        patientTelephone: formData.telephone.trim().replace(/\s+/g, ''),
        patientEmail: formData.email ? formData.email.trim() : '',
        patientDateNaissance: formData.dateNaissance,
        
        // Informations complètes du patient pour la vérification
        patient: {
          id: patientRef.id,
          nom: formData.nom.trim(),
          prenom: formData.prenom.trim(),
          dateNaissance: formData.dateNaissance,
          email: formData.email ? formData.email.trim() : '',
          telephone: formData.telephone.trim().replace(/\s+/g, ''),
          adresse: '',
          sexe: '',
          profession: '',
          structureId: structureId,
          createdAt: createdAt,
          updatedAt: createdAt,
          assurances: [],
          antecedents: {
            medicaux: [],
            chirurgicaux: [],
            familiaux: [],
            allergies: []
          }
        },
        
        // Informations du médecin
        medecinId: formData.medecinId,
        medecinNom: medecin?.nom || '',
        medecinPrenom: medecin?.prenom || '',
        medecinSpecialite: medecin?.specialite || ''
      };
      
      // Ajouter le rendez-vous à la base de données
      const rdvRef = await addDoc(collection(db, 'rendezvous'), rdvData);
      
      console.log("Rendez-vous créé avec succès:", rdvRef.id);
      
      // Nettoyer les données du formulaire dans localStorage
      localStorage.removeItem('quickAppointmentFormData');
      
      // Passer à la vue de succès
      setCurrentView('success');
      
    } catch (error) {
      console.error("Erreur lors de la création du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de la création du rendez-vous. Veuillez réessayer.", 
        type: "error" 
      });
    } finally {
      setLoading(false);
    }
  };

  // Fonction pour vérifier un rendez-vous
  const handleVerifyAppointment = async () => {
    if (!verificationSearchCode) {
      setMessage({ text: "Veuillez entrer un code de vérification", type: "error" });
      return;
    }
    
    try {
      setLoadingVerification(true);
      
      // Rechercher le rendez-vous par code de vérification dans toutes les structures
      const q = query(
        collection(db, 'rendezvous'), 
        where("verificationCode", "==", verificationSearchCode.trim())
      );
      
      const querySnapshot = await getDocs(q);
      
      if (querySnapshot.empty) {
        // Si le rendez-vous n'est pas trouvé dans cette structure, vérifier s'il s'agit d'un code externe
        if (verificationSearchCode.startsWith('EXT')) {
          // Simuler la vérification d'un rendez-vous externe
          // Dans un cas réel, vous feriez une requête à l'API de l'autre structure
          setVerificationResult({
            id: 'external-' + Date.now(),
            patientNom: 'Externe',
            patientPrenom: 'Patient',
            patientTelephone: '77 123 45 67',
            medecinNom: 'Externe',
            medecinPrenom: 'Docteur',
            medecinSpecialite: 'Spécialité externe',
            date: new Date().toISOString().split('T')[0],
            heure: '10:00',
            motif: 'Consultation externe',
            statut: 'confirmé',
            structureNom: 'Structure Externe',
            verificationCode: verificationSearchCode,
            isExternal: true,
            externalVerificationUrl: `https://www.autre-structure.com/verification?code=${verificationSearchCode}`
          });
          setMessage({ text: "Rendez-vous externe trouvé. Pour plus de détails, veuillez consulter la structure concernée.", type: "success" });
        } else {
          setVerificationResult(null);
          setMessage({ text: "Aucun rendez-vous trouvé avec ce code", type: "error" });
        }
      } else {
        // Récupérer les données du premier rendez-vous trouvé
        const rdvData = { id: querySnapshot.docs[0].id, ...querySnapshot.docs[0].data() };
        
        // Récupérer les détails du médecin si nécessaire
        if (rdvData.medecinId) {
          try {
            const medecinDoc = await getDoc(doc(db, 'medecins', rdvData.medecinId));
            if (medecinDoc.exists()) {
              rdvData.medecin = { id: medecinDoc.id, ...medecinDoc.data() };
            }
          } catch (error) {
            console.error("Erreur lors de la récupération des détails du médecin:", error);
          }
        }
        
        setVerificationResult(rdvData);
        setMessage({ text: "Rendez-vous trouvé avec succès", type: "success" });
      }
    } catch (error) {
      console.error("Erreur lors de la vérification du rendez-vous:", error);
      setMessage({ 
        text: "Une erreur est survenue lors de la vérification du rendez-vous", 
        type: "error" 
      });
    } finally {
      setLoadingVerification(false);
    }
  };

  // Réimplémenter la fonction renderCurrentStep qui a été supprimée
  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return (
          <div className="step-content">
            <div className="form-group mb-3">
              <label htmlFor="nom">Nom</label>
              <input
                type="text"
                className="form-control"
                id="nom"
                name="nom"
                value={formData.nom}
                onChange={handleChange}
                placeholder="Votre nom de famille"
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="prenom">Prénom</label>
              <input
                type="text"
                className="form-control"
                id="prenom"
                name="prenom"
                value={formData.prenom}
                onChange={handleChange}
                placeholder="Votre prénom"
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="dateNaissance">Date de naissance</label>
              <input
                type="date"
                className="form-control"
                id="dateNaissance"
                name="dateNaissance"
                value={formData.dateNaissance}
                onChange={handleChange}
                required
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="email">Email</label>
              <input
                type="email"
                className="form-control"
                id="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Votre email"
              />
            </div>
            <div className="form-group mb-3">
              <label htmlFor="telephone">Téléphone*</label>
              <input
                type="tel"
                className="form-control"
                id="telephone"
                name="telephone"
                value={formData.telephone}
                onChange={handleChange}
                placeholder="Votre numéro de téléphone"
                required
              />
            </div>
          </div>
        );
        
      case 2:
        return (
          <div className="step-content">
            
            {/* Sélection de la spécialité - maintenant avec toutes les spécialités disponibles */}
            <div className="form-group mb-3">
              <label htmlFor="specialite">Spécialité médicale*</label>
              <select
                className="form-control"
                id="specialite"
                name="specialite"
                value={selectedSpecialite}
                onChange={handleSpecialiteChange}
                required
                disabled={loadingMedecins}
              >
                <option value="">Sélectionnez une spécialité</option>
                
                {/* Afficher d'abord les spécialités locales */}
                {specialites.length > 0 && (
                  <optgroup label={`Spécialités disponibles chez ${STRUCTURE_NOM}`}>
                    {specialites.map(spec => (
                      <option key={`local-${spec}`} value={spec}>
                        {spec}
                      </option>
                    ))}
                  </optgroup>
                )}
                
                {/* Puis afficher toutes les autres spécialités */}
                {allSpecialites.length > 0 && (
                  <optgroup label="Toutes les spécialités disponibles">
                    {allSpecialites
                      .filter(spec => !specialites.includes(spec))
                      .map(spec => (
                        <option key={`external-${spec}`} value={spec}>
                          {spec} <span className="text-muted">(externe)</span>
                        </option>
                      ))}
                  </optgroup>
                )}
                
                <option value="domicile">Consultation à domicile</option>
              </select>
              {loadingMedecins && (
                <div className="text-muted small mt-1">
                  <FontAwesomeIcon icon={faSpinner} spin className="me-1" />
                  Chargement des spécialités...
                </div>
              )}
            </div>
            
            {/* Afficher les structures externes si une spécialité externe est sélectionnée */}
            {isExternalSpeciality && externalSpecialites.length > 0 && (
              <div className="form-group mb-3">
                <label htmlFor="structureId">Structure médicale*</label>
                <select
                  className="form-control"
                  id="structureId"
                  name="structureId"
                  value={selectedStructure}
                  onChange={handleStructureChange}
                  required
                >
                  <option value="">Sélectionnez une structure</option>
                  {externalSpecialites.map(structure => (
                    <option key={structure.id} value={structure.id}>
                      {structure.nom} {structure.adresse ? `(${structure.adresse})` : ''}
                    </option>
                  ))}
                </select>
                <small className="form-text text-info">
                  <FontAwesomeIcon icon={faInfoCircle} className="me-1" />
                  Cette spécialité est disponible dans d'autres structures. Sélectionnez celle qui vous convient.
                </small>
              </div>
            )}
            
            {/* Sélection du médecin (seulement si une spécialité est sélectionnée) */}
            {selectedSpecialite && selectedSpecialite !== 'domicile' && (
              <div className="form-group mb-3">
                <label htmlFor="medecinId">Médecin*</label>
                <select
                  className="form-control"
                  id="medecinId"
                  name="medecinId"
                  value={formData.medecinId}
                  onChange={handleChange}
                  required
                >
                  <option value="">Sélectionnez un médecin</option>
                  {medecins
                    .filter(m => m.specialite === selectedSpecialite)
                    .map(medecin => (
                      <option key={medecin.id} value={medecin.id}>
                        Dr. {medecin.prenom} {medecin.nom} {medecin.specialite ? `(${medecin.specialite})` : ''}
                      </option>
                    ))}
                </select>
                
                {/* Afficher un indicateur si nous sommes dans une structure externe */}
                {formData.structureId !== STRUCTURE_ID && (
                  <div className="alert alert-info mt-2">
                    <FontAwesomeIcon icon={faHospital} className="me-2" />
                    Vous consultez les médecins de {allStructures.find(s => s.id === formData.structureId)?.nom || 'une autre structure'}
                  </div>
                )}
              </div>
            )}
            
            {/* Sélection de la date */}
            {formData.medecinId && (
              <div className="form-group mb-3">
                <label htmlFor="dateRdv">Date du rendez-vous*</label>
                <input
                  type="date"
                  className="form-control"
                  id="dateRdv"
                  name="dateRdv"
                  value={formData.dateRdv}
                  onChange={handleChange}
                  min={new Date().toISOString().split('T')[0]}
                  required
                />
              </div>
            )}
          </div>
        );
        
      case 3:
        return (
          <div className="step-content">
            <h5>Finalisation du rendez-vous</h5>
            
            {/* Sélection de l'heure */}
            {formData.dateRdv && (
              <div className="form-group mb-4">
                <label htmlFor="heureRdv">Heure du rendez-vous*</label>
                {creneauxDisponibles.length > 0 ? (
                  <div className="creneaux-grid">
                    {creneauxDisponibles.map((creneau, index) => (
                      <button
                        key={index}
                        type="button"
                        className={`btn ${
                          formData.heureRdv === creneau.heure
                            ? 'btn-primary'
                            : creneau.estDisponible
                              ? 'btn-outline-primary'
                              : 'btn-outline-secondary'
                        } creneau-btn m-1`}
                        onClick={() => {
                          if (creneau.estDisponible) {
                            setFormData({ ...formData, heureRdv: creneau.heure });
                          }
                        }}
                        disabled={!creneau.estDisponible}
                      >
                        {creneau.heure}
                        {creneau.statut === 'partiel' && (
                          <span className="badge bg-warning text-dark ms-1">
                            <small>{creneau.nombreRdv}</small>
                          </span>
                        )}
                      </button>
                    ))}
                  </div>
                ) : (
                  <div className="alert alert-warning">
                    <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
                    Aucun créneau disponible pour cette date. Veuillez choisir une autre date.
                  </div>
                )}
              </div>
            )}
            
            {/* Motif du rendez-vous */}
            <div className="form-group mb-3">
              <label htmlFor="motif">Motif du rendez-vous*</label>
              <textarea
                className="form-control"
                id="motif"
                name="motif"
                rows="3"
                value={formData.motif}
                onChange={handleChange}
                placeholder="Décrivez brièvement la raison de votre consultation"
                required
              ></textarea>
            </div>
            
            {/* Résumé du rendez-vous */}
            {formData.heureRdv && (
              <div className="appointment-summary mt-4 p-3 bg-light rounded">
                <h6>Résumé du rendez-vous</h6>
                <p><strong>Patient:</strong> {formData.prenom} {formData.nom}</p>
                <p><strong>Médecin:</strong> Dr. {
                  medecins.find(m => m.id === formData.medecinId)?.prenom
                } {
                  medecins.find(m => m.id === formData.medecinId)?.nom
                }</p>
                
                {/* Afficher la structure si différente de la structure par défaut */}
                {formData.structureId !== STRUCTURE_ID && (
                  <p><strong>Structure:</strong> {
                    allStructures.find(s => s.id === formData.structureId)?.nom || 'Structure externe'
                  }</p>
                )}
                
                <p><strong>Date:</strong> {formatDate(formData.dateRdv)}</p>
                <p><strong>Heure:</strong> {formData.heureRdv}</p>
                <p><strong>Motif:</strong> {formData.motif}</p>
              </div>
            )}
          </div>
        );
        
      default:
        return null;
    }
  };

  // Fonction pour afficher la vue de vérification
  const renderVerificationView = () => {
    return (
      <div className="verification-view">
        <div className="card">
          <div className="card-body">
            <h4 className="card-title mb-4">Vérifier un rendez-vous</h4>
            
            <div className="form-group mb-4">
              <label htmlFor="verificationCode">Code de vérification</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control"
                  id="verificationCode"
                  placeholder="Entrez le code de vérification"
                  value={verificationSearchCode}
                  onChange={(e) => setVerificationSearchCode(e.target.value.toUpperCase())}
                />
                <button
                  className="btn btn-primary"
                  type="button"
                  onClick={handleVerifyAppointment}
                  disabled={loadingVerification}
                >
                  {loadingVerification ? (
                    <FontAwesomeIcon icon={faSpinner} spin className="me-1" />
                  ) : (
                    <FontAwesomeIcon icon={faSearch} className="me-1" />
                  )}
                  Vérifier
                </button>
              </div>
              <small className="form-text text-muted">
                Entrez le code que vous avez reçu lors de la confirmation de votre rendez-vous.
              
              </small>
            </div>
            
            {verificationResult && (
              <div className="verification-result mt-4">
                <div className="alert alert-success">
                  <FontAwesomeIcon icon={faCheck} className="me-2" />
                  Rendez-vous trouvé
                </div>
                
                <div className="card mt-3">
                  <div className="card-header bg-primary text-white">
                    <h5 className="mb-0">
                      <FontAwesomeIcon icon={faCalendarCheck} className="me-2" />
                      Détails du rendez-vous
                    </h5>
                  </div>
                  <div className="card-body">
                    <p><strong>Patient:</strong> {verificationResult.patientPrenom} {verificationResult.patientNom}</p>
                    <p><strong>Téléphone:</strong> {verificationResult.patientTelephone}</p>
                    <p><strong>Médecin:</strong> Dr. {verificationResult.medecinPrenom} {verificationResult.medecinNom}</p>
                    <p><strong>Spécialité:</strong> {verificationResult.medecinSpecialite}</p>
                    <p><strong>Date:</strong> {formatDate(verificationResult.date)}</p>
                    <p><strong>Heure:</strong> {verificationResult.heure}</p>
                    <p><strong>Durée:</strong> 15 minutes</p>
                    <p><strong>Motif du rendez-vous:</strong> {verificationResult.motif}</p>
                    <p><strong>Statut:</strong> <span className={`badge ${
                      verificationResult.statut === 'confirmé' ? 'bg-success' :
                      verificationResult.statut === 'annulé' ? 'bg-danger' :
                      verificationResult.statut === 'en attente' ? 'bg-warning' :
                      'bg-secondary'
                    }`}>{verificationResult.statut}</span></p>
                    
                    {verificationResult.statutPaiement && (
                      <p><strong>Paiement:</strong> <span className={`badge ${
                        verificationResult.statutPaiement === 'payé' ? 'bg-success' :
                        verificationResult.statutPaiement === 'en attente' ? 'bg-warning' :
                        'bg-danger'
                      }`}>{verificationResult.statutPaiement}</span></p>
                    )}
                    
                    {verificationResult.montantPaye && (
                      <p><strong>Montant payé:</strong> {verificationResult.montantPaye} FCFA</p>
                    )}
                    
                    <div className="mt-4">
                      <p className="mb-1"><strong>Structure:</strong> {verificationResult.structureNom}</p>
                      <p className="mb-1"><strong>Code de vérification:</strong> {verificationResult.verificationCode}</p>
                    </div>
                    
                    {/* Afficher un lien vers la structure externe si nécessaire */}
                    {verificationResult.isExternal && (
                      <div className="mt-3 text-center">
                        <a 
                          href={verificationResult.externalVerificationUrl} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="btn btn-outline-primary"
                        >
                          <FontAwesomeIcon icon={faExchangeAlt} className="me-2" />
                          Voir les détails sur la structure d'origine
                        </a>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        
        <div className="mt-4 text-center">
          <button
            className="btn btn-secondary"
            onClick={() => {
              setCurrentView('booking');
              setVerificationResult(null);
              setVerificationSearchCode('');
            }}
          >
            <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
            Retour à la prise de rendez-vous
          </button>
        </div>
      </div>
    );
  };

  // Fonction pour afficher la vue de succès
  const renderSuccessView = () => {
    // Trouver le nom de la structure
    let structureNom = STRUCTURE_NOM;
    if (formData.structureId !== STRUCTURE_ID) {
      const structure = allStructures.find(s => s.id === formData.structureId);
      if (structure) {
        structureNom = structure.nom;
      }
    }
    
    // Si nous avons un code de vérification externe, afficher les informations externes
    if (verificationCode) {
      return (
        <div className="success-view">
          <div className="alert alert-success">
            <FontAwesomeIcon icon={faCheck} className="me-2" />
            Votre rendez-vous a été confirmé avec succès!
          </div>
          
          <div className="verification-code-box mt-4 mb-4 p-3 bg-light rounded text-center">
            <h5>Votre code de vérification</h5>
            <div className="code-display p-2 my-2 bg-white rounded border">
              <h3 className="mb-0">{verificationCode}</h3>
            </div>
            <p className="small text-muted mb-0">
              Conservez ce code. Il vous permettra de vérifier votre rendez-vous.
              <br/>
            </p>
          </div>
          
          <div className="appointment-details mt-4">
            <div className="card">
              <div className="card-body">
                <h5 className="card-title">Détails du rendez-vous</h5>
                <p><strong>Structure:</strong> {structureNom}</p>
                <p><strong>Patient:</strong> {formData.prenom} {formData.nom}</p>
                <p><strong>Date de naissance:</strong> {formatDate(formData.dateNaissance)}</p>
                <p><strong>Téléphone:</strong> {formData.telephone}</p>
                <p><strong>Médecin:</strong> Dr. {medecins.find(m => m.id === formData.medecinId)?.prenom} {medecins.find(m => m.id === formData.medecinId)?.nom}</p>
                <p><strong>Spécialité:</strong> {medecins.find(m => m.id === formData.medecinId)?.specialite}</p>
                <p><strong>Date:</strong> {formatDate(formData.dateRdv)}</p>
                <p><strong>Heure:</strong> {formData.heureRdv}</p>
                <p><strong>Motif:</strong> {formData.motif}</p>
              </div>
            </div>
          </div>
          
          <div className="mt-4 text-center">
            <button
              className="btn btn-primary"
              onClick={() => {
                // Réinitialiser le formulaire et revenir à l'étape initiale
                setFormData({
                  nom: '',
                  prenom: '',
                  dateNaissance: '',
                  email: '',
                  telephone: '',
                  dateRdv: '',
                  heureRdv: '',
                  medecinId: '',
                  motif: '',
                  statut: 'confirmé',
                  structureId: STRUCTURE_ID
                });
                setCurrentStep(1);
                setCurrentView('booking');
                setVerificationCode('');
                setSelectedSpecialite('');
                setSelectedStructure(STRUCTURE_ID);
                setIsExternalSpeciality(false);
              }}
            >
              Prendre un nouveau rendez-vous
            </button>
          </div>
        </div>
      );
    }
    
    // Sinon, afficher les informations du rendez-vous local
    const medecin = medecins.find(m => m.id === formData.medecinId);
    
    return (
      <div className="success-view">
        <div className="alert alert-success">
          <FontAwesomeIcon icon={faCheck} className="me-2" />
          Votre rendez-vous a été confirmé avec succès!
        </div>
        
        <div className="verification-code-box mt-4 mb-4 p-3 bg-light rounded text-center">
          <h5>Votre code de vérification</h5>
          <div className="code-display p-2 my-2 bg-white rounded border">
            <h3 className="mb-0">{verificationCode}</h3>
          </div>
          <p className="small text-muted mb-0">
            Conservez ce code. Il vous sera demandé pour confirmer votre présence.
            <br/>Ce code est valide dans toutes les structures du réseau.
          </p>
        </div>
        
        <div className="appointment-details mt-4">
          <div className="card">
            <div className="card-body">
              
            <h5 className="card-title">Détails du rendez-vous</h5>
              <p><strong>Structure:</strong> {structureNom}</p>
              <p><strong>Patient:</strong> {formData.prenom} {formData.nom}</p>
              <p><strong>Date de naissance:</strong> {formatDate(formData.dateNaissance)}</p>
              <p><strong>Téléphone:</strong> {formData.telephone}</p>
              <p><strong>Médecin:</strong> Dr. {medecin?.prenom} {medecin?.nom}</p>
              <p><strong>Spécialité:</strong> {medecin?.specialite}</p>
              <p><strong>Date:</strong> {formatDate(formData.dateRdv)}</p>
              <p><strong>Heure:</strong> {formData.heureRdv}</p>
              <p><strong>Durée:</strong> 15 minutes</p>
              <p><strong>Motif:</strong> {formData.motif}</p>
            </div>
          </div>
        </div>
        
        <div className="mt-4 text-center">
          <button
            className="btn btn-primary"
            onClick={() => {
              // Réinitialiser le formulaire et revenir à l'étape initiale
              setFormData({
                nom: '',
                prenom: '',
                dateNaissance: '',
                email: '',
                telephone: '',
                dateRdv: '',
                heureRdv: '',
                medecinId: '',
                motif: '',
                statut: 'confirmé',
                structureId: STRUCTURE_ID
              });
              setCurrentStep(1);
              setCurrentView('booking');
              setVerificationCode('');
              setSelectedSpecialite('');
              setSelectedStructure(STRUCTURE_ID);
              setIsExternalSpeciality(false);
            }}
          >
            Prendre un nouveau rendez-vous
          </button>
        </div>
      </div>
    );
  };

  // Fonction pour afficher la vue de réservation
  const renderBookingView = () => {
    return (
      <div className="booking-view">
        {/* Afficher les étapes du formulaire */}
        <div className="steps-indicator mb-4">
          <div className={`step ${currentStep >= 1 ? 'active' : ''}`}>
            <div className="step-number">1</div>
            <div className="step-label">Informations</div>
          </div>
          <div className="step-connector"></div>
          <div className={`step ${currentStep >= 2 ? 'active' : ''}`}>
            <div className="step-number">2</div>
            <div className="step-label">Professionnel de santé</div>
          </div>
          <div className="step-connector"></div>
          <div className={`step ${currentStep >= 3 ? 'active' : ''}`}>
            <div className="step-number">3</div>
            <div className="step-label">Finalisation</div>
          </div>
        </div>
        
        {/* Afficher les messages d'erreur ou de succès */}
        {message.text && (
          <div className={`alert alert-${message.type === 'error' ? 'danger' : message.type === 'info' ? 'info' : 'success'} mb-4`}>
            {message.type === 'error' ? (
              <FontAwesomeIcon icon={faTimes} className="me-2" />
            ) : message.type === 'info' ? (
              <FontAwesomeIcon icon={faInfoCircle} className="me-2" />
            ) : (
              <FontAwesomeIcon icon={faCheck} className="me-2" />
            )}
            {message.text}
          </div>
        )}
        
        {/* Formulaire de rendez-vous */}
        <form onSubmit={handleSubmit}>
          {/* Contenu de l'étape actuelle */}
          {renderCurrentStep()}
          
          {/* Boutons de navigation */}
          <div className="form-navigation mt-4 d-flex justify-content-between">
            {currentStep > 1 && (
              <button
                type="button"
                className="btn btn-secondary"
                onClick={handlePrevStep}
                disabled={loading}
              >
                <FontAwesomeIcon icon={faArrowLeft} className="me-2" />
                Précédent
              </button>
            )}
            
            <div className="ms-auto">
              {currentStep < 3 ? (
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleNextStep}
                  disabled={!isCurrentStepValid() || loading}
                >
                  Suivant
                  <FontAwesomeIcon icon={faArrowLeft} className="ms-2 fa-flip-horizontal" />
                </button>
              ) : (
                <button
                  type="submit"
                  className="btn btn-success"
                  disabled={!isCurrentStepValid() || loading}
                >
                  {loading ? (
                    <>
                      <FontAwesomeIcon icon={faSpinner} spin className="me-2" />
                      Traitement en cours...
                    </>
                  ) : (
                    <>
                      <FontAwesomeIcon icon={faCheck} className="me-2" />
                      Confirmer le rendez-vous
                    </>
                  )}
                </button>
              )}
            </div>
          </div>
        </form>
        
        {/* Lien pour vérifier un rendez-vous existant */}
        <div className="mt-4 text-center">
          <button
            className="btn btn-link"

            onClick={() => setCurrentView('verification')}
          >
            <FontAwesomeIcon icon={faSearch} className="me-1" />
            Vérifier un rendez-vous existant
          </button>
        
        </div>
      </div>
    );
  };

  // Rendu principal du composant
  return (
    <div className="quick-container">

      
      <div className="quick-content">
        {/* Afficher la vue appropriée */}
        {currentView === 'booking' && renderBookingView()}
        {currentView === 'success' && renderSuccessView()}
        {currentView === 'verification' && renderVerificationView()}
      </div>
      
      {/* Iframe pour les consultations à domicile ou autres spécialités */}
      {showIframe && (
        <div className="iframe-overlay">
          <div className="iframe-container">
            <div className="iframe-header">
              <h4>{iframeTitle}</h4>
              <button 
                type="button" 
                className="btn-close" 
                onClick={() => {
                  setShowIframe(false);
                  setSelectedSpecialite('');
                }}
                aria-label="Fermer"
              ></button>
            </div>
            <iframe
              src={iframeUrl}
              title={iframeTitle}
              className="embedded-iframe"
              frameBorder="0"
              allowFullScreen
            ></iframe>
            <div className="iframe-footer">
              <button
                className="btn btn-secondary"
                onClick={() => {
                  setShowIframe(false);
                  setSelectedSpecialite('');
                }}
              >
                Annuler et revenir
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Modal pour les consultations à domicile (version alternative) */}
      {showHomeConsultModal && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h4>Consultation à domicile</h4>
            <p>
              Pour les consultations à domicile, veuillez contacter directement notre service client
              au <strong>77 123 45 67</strong> pour organiser votre rendez-vous.
            </p>
            <div className="modal-actions">
              <button                
                className="btn btn-primary"
                onClick={() => {
                  setShowHomeConsultModal(false);
                  setSelectedSpecialite('');
                }}
              >
                Compris
              </button>
            </div>
          </div>
        </div>
      )}
      
      {/* Styles CSS spécifiques au composant */}
      <style jsx>{`
       /* Quick.css */

:root {
  --primary-color: #0056b3;
  --secondary-color: #6c757d;
  --success-color: #28a745;
  --danger-color: #dc3545;
  --warning-color: #ffc107;
  --info-color: #17a2b8;
  --light-color: #f8f9fa;
  --dark-color: #343a40;
  --white: #ffffff;
  --shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  --border-radius: 0.25rem;
  --transition: all 0.3s ease;
  --font-family: 'Poppins', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
}

/* Container principal */
.quick-container {
  font-family: var(--font-family);
  max-width: 1000px;
  margin: 0 auto;
  padding: 2rem 1rem;
  background-color: var(--white);
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.05);
}

.quick-header {
  text-align: center;
  margin-bottom: 2rem;
}

.quick-header h2 {
  color: var(--primary-color);
  font-weight: 600;
  margin-bottom: 0.5rem;
}

.quick-header p {
  color: var(--secondary-color);
  font-size: 1rem;
}

.quick-content {
  padding: 1rem;
}

/* Navigation entre les panels */
.panel-navigation {
  display: flex;
  justify-content: space-around;
  margin-bottom: 2rem;
  border-bottom: 1px solid #eee;
}

.panel-tab {
  padding: 1rem;
  cursor: pointer;
  font-weight: 500;
  position: relative;
  color: var(--secondary-color);
  transition: var(--transition);
  text-align: center;
  flex: 1;
}

.panel-tab.active {
  color: var(--primary-color);
}

.panel-tab.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 3px;
  background-color: var(--primary-color);
}

.panel-tab:hover {
  color: var(--primary-color);
}

.panel-tab i {
  margin-right: 0.5rem;
}

/* Indicateur d'étapes */
.steps-indicator {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 2rem;
}

.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  z-index: 1;
}

.step-number {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  background-color: var(--light-color);
  border: 2px solid var(--secondary-color);
  color: var(--secondary-color);
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  margin-bottom: 0.5rem;
  transition: var(--transition);
}

.step.active .step-number {
  background-color: var(--primary-color);
  border-color: var(--primary-color);
  color: var(--white);
}

.step-label {
  font-size: 0.875rem;
  color: var(--secondary-color);
  font-weight: 500;
  transition: var(--transition);
}

.step.active .step-label {
  color: var(--primary-color);
  font-weight: 600;
}

.step-connector {
  flex-grow: 1;
  height: 2px;
  background-color: var(--secondary-color);
  margin: 0 10px;
  position: relative;
  top: -18px;
  z-index: 0;
}

/* Formulaire */
.form-group {
  margin-bottom: 1.5rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: var(--dark-color);
}

.form-control {
  width: 100%;
  padding: 0.75rem;
  font-size: 1rem;
  border: 1px solid #ced4da;
  border-radius: var(--border-radius);
  transition: var(--transition);
}

.form-control:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
  outline: none;
}

.form-text {
  font-size: 0.875rem;
  color: var(--secondary-color);
  margin-top: 0.25rem;
}

/* Boutons */
.btn {
  display: inline-block;
  font-weight: 500;
  text-align: center;
  white-space: nowrap;
  vertical-align: middle;
  user-select: none;
  border: 1px solid transparent;
  padding: 0.75rem 1.5rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: var(--border-radius);
  transition: var(--transition);
  cursor: pointer;
}

.btn:focus {
  outline: none;
  box-shadow: 0 0 0 0.2rem rgba(0, 123, 255, 0.25);
}

.btn:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.btn-primary {
  color: var(--white);
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.btn-primary:hover:not(:disabled) {
  background-color: #004494;
  border-color: #003d84;
}

.btn-secondary {
  color: var(--white);
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);
}

.btn-secondary:hover:not(:disabled) {
  background-color: #5a6268;
  border-color: #545b62;
}

.btn-success {
  color: var(--white);
  background-color: var(--success-color);
  border-color: var(--success-color);
}

.btn-success:hover:not(:disabled) {
  background-color: #218838;
  border-color: #1e7e34;
}

.btn-outline-primary {
  color: var(--primary-color);
  background-color: transparent;
  border-color: var(--primary-color);
}

.btn-outline-primary:hover:not(:disabled) {
  color: var(--white);
  background-color: var(--primary-color);
  border-color: var(--primary-color);
}

.btn-outline-secondary {
  color: var(--secondary-color);
  background-color: transparent;
  border-color: var(--secondary-color);
}

.btn-outline-secondary:hover:not(:disabled) {
  color: var(--white);
  background-color: var(--secondary-color);
  border-color: var(--secondary-color);
}

.btn-link {
  font-weight: 400;
  color: var(--primary-color);
  background-color: transparent;
  border: none;
  padding: 0.5rem;
  text-decoration: underline;
}

.btn-link:hover {
  color: #004494;
  text-decoration: underline;
}

/* Grille de créneaux */
.creneaux-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(100px, 1fr));
  gap: 0.5rem;
  margin-top: 1rem;
}

.creneau-btn {
  padding: 0.5rem;
  font-size: 0.875rem;
  text-align: center;
  border-radius: var(--border-radius);
  transition: var(--transition);
  position: relative;
}

/* Résumé du rendez-vous */
.appointment-summary {
  background-color: var(--light-color);
  padding: 1.5rem;
  border-radius: var(--border-radius);
  margin-top: 2rem;
  box-shadow: var(--shadow);
}

.appointment-summary h6 {
  color: var(--primary-color);
  margin-bottom: 1rem;
  font-weight: 600;
}

.appointment-summary p {
  margin-bottom: 0.5rem;
}

.appointment-summary p:last-child {
  margin-bottom: 0;
}

/* Alertes */
.alert {
  position: relative;
  padding: 1rem;
  margin-bottom: 1rem;
  border: 1px solid transparent;
  border-radius: var(--border-radius);
}

.alert-success {
  color: #155724;
  background-color: #d4edda;
  border-color: #c3e6cb;
}

.alert-danger {
  color: #721c24;
  background-color: #f8d7da;
  border-color: #f5c6cb;
}

.alert-warning {
  color: #856404;
  background-color: #fff3cd;
  border-color: #ffeeba;
}

.alert-info {
  color: #0c5460;
  background-color: #d1ecf1;
  border-color: #bee5eb;
}

/* Vue de succès */
.success-view {
  text-align: center;
  padding: 2rem 1rem;
}

.verification-code-box {
  background-color: var(--light-color);
  padding: 2rem;
  border-radius: var(--border-radius);
  margin: 2rem auto;
  max-width: 500px;
  box-shadow: var(--shadow);
}

.code-display {
  background-color: var(--white);
  padding: 1.5rem;
  border-radius: var(--border-radius);
  border: 2px dashed var(--primary-color);
  margin: 1rem 0;
}

.code-display h3 {
  color: var(--primary-color);
  font-weight: 700;
  letter-spacing: 2px;
}

.appointment-details {
  max-width: 600px;
  margin: 0 auto;
}

/* Vue de vérification */
.verification-view {
  max-width: 700px;
  margin: 0 auto;
}

.verification-result {
  margin-top: 2rem;
}

/* Badges */
.badge {
  display: inline-block;
  padding: 0.25em 0.4em;
  font-size: 75%;
  font-weight: 700;
  line-height: 1;
  text-align: center;
  white-space: nowrap;
  vertical-align: baseline;
  border-radius: 0.25rem;
}

.bg-success {
  background-color: var(--success-color) !important;
  color: var(--white);
}

.bg-danger {
  background-color: var(--danger-color) !important;
  color: var(--white);
}

.bg-warning {
  background-color: var(--warning-color) !important;
  color: #212529;
}

.bg-info {
  background-color: var(--info-color) !important;
  color: var(--white);
}

.bg-secondary {
  background-color: var(--secondary-color) !important;
  color: var(--white);
}

.bg-primary {
  background-color: var(--primary-color) !important;
  color: var(--white);
}

/* Iframe et modals */
.iframe-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.iframe-container {
  width: 90%;
  max-width: 1200px;
  height: 90vh;
  background-color: var(--white);
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
}

.iframe-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
  background-color: var(--primary-color);
  color: var(--white);
}

.iframe-header h4 {
  margin: 0;
}

.btn-close {
  background: transparent;
  border: none;
  color: var(--white);
  font-size: 1.5rem;
  cursor: pointer;
}

.embedded-iframe {
  flex-grow: 1;
  width: 100%;
  border: none;
}

.iframe-footer {
  padding: 1rem;
  text-align: right;
  border-top: 1px solid #eee;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1050;
}

.modal-content {
  width: 90%;
  max-width: 500px;
  background-color: var(--white);
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
}

.modal-content h4 {
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.modal-actions {
  margin-top: 1.5rem;
  display: flex;
  justify-content: flex-end;
}

/* Cartes */
.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: var(--white);
  background-clip: border-box;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: var(--border-radius);
  box-shadow: var(--shadow);
}

.card-header {
  padding: 0.75rem 1.25rem;
  margin-bottom: 0;
  background-color: rgba(0, 0, 0, 0.03);
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
}

.card-body {
  flex: 1 1 auto;
  padding: 1.25rem;
}

.card-title {
  margin-bottom: 0.75rem;
  font-weight: 600;
  color: var(--primary-color);
}

/* Utilitaires */
.text-center {
  text-align: center;
}

.text-muted {
  color: var(--secondary-color) !important;
}

.small {
  font-size: 0.875rem;
}

.mt-1 { margin-top: 0.25rem !important; }
.mt-2 { margin-top: 0.5rem !important; }
.mt-3 { margin-top: 1rem !important; }
.mt-4 { margin-top: 1.5rem !important; }
.mb-0 { margin-bottom: 0 !important; }
.mb-1 { margin-bottom: 0.25rem !important; }
.mb-2 { margin-bottom: 0.5rem !important; }
.mb-3 { margin-bottom: 1rem !important; }
.mb-4 { margin-bottom: 1.5rem !important; }
.ms-1 { margin-left: 0.25rem !important; }
.ms-2 { margin-left: 0.5rem !important; }
.ms-auto { margin-left: auto !important; }
.me-1 { margin-right: 0.25rem !important; }
.me-2 { margin-right: 0.5rem !important; }
.p-2 { padding: 0.5rem !important; }
.p-3 { padding: 1rem !important; }
.pt-3 { padding-top: 1rem !important; }

.d-flex {
  display: flex !important;
}

.justify-content-between {
  justify-content: space-between !important;
}

.border-top {
  border-top: 1px solid #dee2e6 !important;
}

.rounded {
  border-radius: var(--border-radius) !important;
}

.border {
  border: 1px solid #dee2e6 !important;
}

/* Responsive */
@media (max-width: 768px) {
  .quick-container {
    padding: 1rem;
  }
  
  .steps-indicator {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .step {
    flex-direction: row;
    width: 100%;
    margin-bottom: 0.5rem;
  }
  
  .step-number {
    margin-bottom: 0;
    margin-right: 1rem;
  }
  
  .step-connector {
    display: none;
  }
  
  .creneaux-grid {
    grid-template-columns: repeat(auto-fill, minmax(80px, 1fr));
  }
  
  .form-navigation {
    flex-direction: column;
    gap: 1rem;
  }
  
  .form-navigation button {
    width: 100%;
  }
}

/* Animations */
@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

.fade-in {
  animation: fadeIn 0.3s ease-in-out;
}

@keyframes slideUp {
  from { transform: translateY(20px); opacity: 0; }
  to { transform: translateY(0); opacity: 1; }
}

.slide-up {
  animation: slideUp 0.3s ease-in-out;
}

/* Styles spécifiques pour les éléments de paiement */
.payment-info {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: var(--border-radius);
  margin-top: 1rem;
}

.payment-methods {
  display: flex;
  gap: 1rem;
  margin-top: 1rem;
}

.payment-method {
  border: 2px solid #dee2e6;
  border-radius: var(--border-radius);
  padding: 1rem;
  text-align: center;
  cursor: pointer;
  transition: var(--transition);
  flex: 1;
}

.payment-method:hover {
  border-color: var(--primary-color);
}

.payment-method.selected {
  border-color: var(--primary-color);
  background-color: rgba(0, 86, 179, 0.05);
}

.payment-method-icon {
  font-size: 2rem;
  margin-bottom: 0.5rem;
  color: var(--primary-color);
}

/* Style pour la vue initiale */
.initial-view {
  text-align: center;
  padding: 3rem 1rem;
}

.service-options {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 1.5rem;
  margin-top: 2rem;
}

.service-option {
  background-color: var(--white);
  border-radius: var(--border-radius);
  padding: 2rem;
  box-shadow: var(--shadow);
  transition: var(--transition);
  text-align: center;
  cursor: pointer;
}

.service-option:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.1);
}

.service-icon {
  font-size: 3rem;
  color: var(--primary-color);
  margin-bottom: 1rem;
}

.service-title {
  font-weight: 600;
  margin-bottom: 0.5rem;
  color: var(--dark-color);
}

.service-description {
  color: var(--secondary-color);
  font-size: 0.875rem;
}

      `}</style>
    
    </div>
  );
};

export default Quick;













































